import React, { useEffect } from 'react';
import { HeaderContent } from '../../components/Layout/HeaderContent';
import { BoxContent } from './styles';
import { Footer } from '../../components/Layout/Footer';
import { Middle } from '../../components/Layout/Middle';
import { useParams, useNavigate } from 'react-router-dom';
import { FaWhatsapp, FaInstagram, FaFacebookF, FaTiktok } from "react-icons/fa";

const Bienvenidos = () => {

    const { slug, producto } = useParams();

    const openWhatsApp = (phone, text = "") => {
        // limpia el número y genera la URL compatible con wa.me
        const clean = phone.replace(/\D/g, ""); // elimina todo lo que no sea dígito
        const url = `https://wa.me/${clean}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
        window.open(url, "_blank");
    }

    useEffect(() => {
        if (!slug) return;
        if (slug === "conocenos" || slug === "eventos") {
            const id = slug === "conocenos" ? "conocenos" : "eventos";
            const el = document.getElementById(id);
            if (el) {
                // pequeño delay por si el DOM aún está renderizando
                setTimeout(() => {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                }, 750);
            }
        }
    }, [slug]); 

    return (
        <BoxContent>
            <div className='container'>
            <div 
                className='wp_contact_float'
                onClick={() => openWhatsApp("+54 9 11 2473-4769", "Hola")} 
            >
                <div className='wp_icon_float'>
                    <FaWhatsapp />
                </div>
                {/* <div className='wp_numero'>+54 9 11 2473-4769</div> */}
            </div>

            <div className='header' id='conocenos'>
                <img src='/images/header_bienvenidos1.jpg' />
            </div>
            {/* <HeaderContent /> */}
            {/* <div className='video_bienvenida'>
                <video src="/bienvenidos.mp4" muted autoPlay loop> </video>
            </div> */}
            <div className='box back_marron_tierra'>
                <div className='inner'>
                    <div className="title">
                        <span className="bienvenidos text_blanco_huevo">BIENVENIDOS A <span className='mercado_rural'>MERCADO RURAL</span></span>
                    </div>
                    <div className='description text_blanco_huevo'><span className='text_amarillo_banana'>Ubicado en Caballito,</span> en medio de la ciudad, 1100 m2 totalmente reciclados con materiales 
nobles: madera, vidrios de colores y acero; transforman al <span className='text_amarillo_banana'>MERCADO RURAL</span> en una 
pintoresca manifestación del arte rural<br/><span className='text_amarillo_banana'>y en un patio gastronómico incomparable</span> 
con platos del campo a la mesa.
</div>
                    {/* <div className='description text_blanco_huevo'><span className='text_amarillo_banana'>Descubrí un espacio donde el campo y la ciudad se encuentran</span> y acercan a tus manos productos seleccionados directamente de productores locales.</div> */}
                </div>
            </div>
            <div className="box">
                <div className="image">
                    <img src={`/images/image_c.jpg`} />
                </div>
            </div>
            <div className='box back_marron_tierra'>
                <div className='inner'>
                    <div className='description text_blanco_huevo'>Menú campero, con gran variedad de <span className='text_amarillo_banana'>Sándwiches, Picadas, Pizzas, Empanadas y Ensaladas de la huerta.</span> Especiales de la semana todo casero!  Horno de Barro y Parrilla los domingos. En algunas ocasiones hay <span className='text_amarillo_banana'>Salad Bar.</span></div>
                </div>
            </div>

            <div className="box">
                <div className="image">
                    <img src={`/images/image_d_1.jpg`} />
                </div>
            </div>
            <div className="box">
                <div className="image">
                    <img src={`/images/image_d.jpg`} />
                </div>
            </div>
            
            <div className='box back_marron_tierra'>
                <div className='inner'>
                    <div className='description text_blanco_huevo'>Degustaciones, música en vivo, cocción en vivo y actividades para toda la familia. Somos Pet Friendly.</div>
                </div>
            </div>


            <div className="box">
                <div className="image">
                    <img src={`/images/image_e.jpg`} />
                </div>
            </div>
            <div className='box back_marron_tierra'>
                <div className='inner'>
                    <div className='description text_blanco_huevo'>No te pierdas esta experiencia única del campo en medio de la ciudad. Consultá en Instagram los días y horarios de atención o por whatsapp. ¡Nos vemos!</div>
                </div>
            </div>
            <div className="box">
                <div className="image">
                    <img src={`/images/image_f.jpg`} />
                </div>
            </div>
            
            {/* <div className='box back_marron_tierra'>
                <div className='inner'>
                    <div className='description text_blanco_huevo'>Si buscás alimentos frescos, productos artesanales o simplemente un lugar para conectar con lo natural, Mercado Rural es tu punto de encuentro. <span className='text_amarillo_banana'>Formá parte de esta comunidad y llevate lo mejor del campo a tu mesa.</span></div>
                </div>
            </div>
            <div className="box">
                <div className="image">
                    <img src={`/images/bienvenidos2.jpg`} />
                </div>
            </div> */}

            <Middle />

            <div className="box" id='eventos'>
                <div className="image">
                    <img src={`/images/image_g.jpg`} />
                </div>
            </div>
            <div className='box back_marron_tierra'>
                <div className='inner'>
                    <div className="title">
                        <span className="bienvenidos text_blanco_huevo">EVENTOS & RESERVAS GRUPALES</span>
                    </div>
                    <div className='description text_blanco_huevo'><span className='text_amarillo_banana'>Dos espacios ideales para celebraciones</span> de fin de año, familiares, de trabajo, despedidas, cumpleaños, egresos, bodas o aniversarios. 
</div>
                    {/* <div className='description text_blanco_huevo'><span className='text_amarillo_banana'>Descubrí un espacio donde el campo y la ciudad se encuentran</span> y acercan a tus manos productos seleccionados directamente de productores locales.</div> */}
                </div>
            </div>

            <div className="box">
                <div className="image">
                    <img src={`/images/image_e_1.jpg`} />
                </div>
            </div>

            <div className='box back_marron_tierra'>
                <div className='inner'>
                    <div className="title">
                        <span className="bienvenidos text_amarillo_banana">Salón Alma Rural:</span>
                    </div>
                    <div className='description text_blanco_huevo'><span className='text_amarillo_banana'>Mesas rodeando</span> un gomero histórico conservado, declarado <span className='text_amarillo_banana'>el Alma del Mercado.</span> Un espacio que <span className='text_amarillo_banana'>nos regala atardeceres mágicos.</span></div>
                    {/* <div className='description text_blanco_huevo'><span className='text_amarillo_banana'>Descubrí un espacio donde el campo y la ciudad se encuentran</span> y acercan a tus manos productos seleccionados directamente de productores locales.</div> */}
                </div>
            </div>

            <div className="box">
                <div className="image">
                    <img src={`/images/image_i.jpg`} />
                </div>
            </div>

            <div className='box back_marron_tierra'>
                <div className='inner'>
                    <div className="title">
                        <span className="bienvenidos text_amarillo_banana">El Patio del Mercado:</span>
                    </div>
                    <div className='description text_blanco_huevo'><span className='text_amarillo_banana'>Un espacio al aire libre</span> para compartir con música y olor a leña de <span className='text_amarillo_banana'>una experiencia el campo en medio de la ciudad,</span> viendo el tren pasar…</div>
                    {/* <div className='description text_blanco_huevo'><span className='text_amarillo_banana'>Descubrí un espacio donde el campo y la ciudad se encuentran</span> y acercan a tus manos productos seleccionados directamente de productores locales.</div> */}
                </div>
            </div>

            <div className="box">
                <div className="image">
                    <img src={`/images/image_j.jpg`} />
                </div>
            </div>

            <Footer />
            </div>  
        </BoxContent>
    );
};

export default Bienvenidos;